import React from 'react'

export default function MoreCircleSVG({ className }: { className?: string }) {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className='stroked' fillRule="evenodd" clipRule="evenodd" d="M12 2.75C17.108 2.75 21.25 6.891 21.25 12C21.25 17.108 17.108 21.25 12 21.25C6.891 21.25 2.75 17.108 2.75 12C2.75 6.892 6.892 2.75 12 2.75Z" stroke="#2B1E15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path className='stroked' d="M15.9389 12.0137H15.9479" stroke="#2B1E15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path className='stroked' d="M11.931 12.0137H11.94" stroke="#2B1E15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path className='stroked' d="M7.92128 12.0137H7.93028" stroke="#2B1E15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
